import { createAction, createReducer } from "@reduxjs/toolkit"
import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"
import { api } from "./helpers/api"
import { PAGINATION_INITIAL_STATE } from "./constants"

// ACTIONS
export const requestedBookingQuestionnaire = createAction("question/requestedBookingQuestionnaire")
export const receivedBookingQuestionnaire = createAction("question/receivedBookingQuestionnaire")
export const failedBookingQuestionnaire = createAction("question/failedBookingQuestionnaire")

export const submittingQuestionnaire = createAction("question/submittingQuestionnaire")
export const submitQuestionnaireSuccess = createAction("question/submitQuestionnaireSuccess")
export const submitQuestionnaireFailure = createAction("question/submitQuestionnaireFailure")

export const requestedQuestionnaireTemplates = createAction("question/requestedQuestionnaireTemplates")
export const receivedQuestionnaireTemplates = createAction("question/receivedQuestionnaireTemplates")
export const failedQuestionnaireTemplates = createAction("question/failedQuestionnaireTemplates")

export const requestedQuestionnaireTemplate = createAction("question/requestedQuestionnaireTemplate")
export const receivedQuestionnaireTemplate = createAction("question/receivedQuestionnaireTemplate")
export const failedQuestionnaireTemplate = createAction("question/failedQuestionnaireTemplate")

export const requestingSaveTemplateQuestions = createAction("question/requestingSaveTemplateQuestions")
export const saveTemplateQuestionsSuccess = createAction("question/saveTemplateQuestionsSuccess")
export const saveTemplateQuestionsFailure = createAction("question/saveTemplateQuestionsFailure")

export const requestingCreateTemplate = createAction("question/requestingCreateTemplate")
export const createTemplateSuccess = createAction("question/createTemplateSuccess")
export const createTemplateFailure = createAction("question/createTemplateFailure")

export const requestingUpdateTemplate = createAction("question/requestingUpdateTemplate")
export const updateTemplateSuccess = createAction("question/updateTemplateSuccess")
export const updateTemplateFailure = createAction("question/updateTemplateFailure")

export const requestingDuplicateTemplate = createAction("question/requestingDuplicateTemplate")
export const duplicateTemplateSuccess = createAction("question/duplicateTemplateSuccess")
export const duplicateTemplateFailure = createAction("question/duplicateTemplateFailure")

export const addQuestion = createAction("question/addQuestion", (question) => ({
  payload: {
    ...question,
    id: Date.now(),
  required: question.required === undefined ? true : question.required,
    options: question.options || [],
    dropdownOptions: question.dropdownOptions || [],
    radioOptions: question.radioOptions || [],
    selectedRadioOption: ''
  }
}))

export const updateQuestion = createAction("question/updateQuestion")
export const deleteQuestion = createAction("question/deleteQuestion")
export const reorderQuestions = createAction("question/reorderQuestions")
export const resetQuestions = createAction("question/resetQuestions")
// Delete template actions
export const requestingDeleteTemplate = createAction("question/requestingDeleteTemplate")
export const deleteTemplateSuccess = createAction("question/deleteTemplateSuccess")
export const deleteTemplateFailure = createAction("question/deleteTemplateFailure")


// REDUCER
const initialState = {
  ...LOADING_INITIAL_STATE,
  questions: [],
  questionnaireTemplates: {
    ...LOADING_INITIAL_STATE,
    data: [],
  },
  bookingQuestionnaire: {
    ...LOADING_INITIAL_STATE,
    data: null,
  },
  currentTemplate: {
    ...LOADING_INITIAL_STATE,
    data: null,
  },
   templateQuestions: {
    // ...LOADING_INITIAL_STATE,
    data: null,
  },
  metadata:{
    ...PAGINATION_INITIAL_STATE,
  },
  questionaire_data:{
    ...LOADING_INITIAL_STATE,
    data: null,
  }
}

const questionReducer = createReducer(initialState, {
  // Booking Questionnaire
  [requestedBookingQuestionnaire.type]: (state) => {
    state.questionaire_data.loading = true
    state.questionaire_data.error = null
  },
  [receivedBookingQuestionnaire.type]: (state, action) => {
    // debugger
    state.questionaire_data.loading = false
    state.questionaire_data.error = null
    state.questionaire_data.data = action.payload
  },
  [failedBookingQuestionnaire.type]: (state, action) => {
    state.questionaire_data.loading = false
    state.questionaire_data.error = action.payload || 'Failed to fetch booking questionnaire'
    state.questionaire_data.data = null
  },

  // Questionnaire Templates
  [requestedQuestionnaireTemplates.type]: (state) => {
    setRequested(state)
  },
  [receivedQuestionnaireTemplates.type]: (state, action) => {
    setReceived(state)
    state.questionnaireTemplates.data = action.payload.data
    state.metadata = action.payload.metadata
  },
  [failedQuestionnaireTemplates.type]: (state) => {
    setFailed(state)
  },
  
  // Single Questionnaire Template
  [requestedQuestionnaireTemplate.type]: (state) => {
    state.currentTemplate.loading = true
    state.currentTemplate.error = null
  },
  [receivedQuestionnaireTemplate.type]: (state, action) => {
    // debugger
    state.currentTemplate.loading = false
    state.currentTemplate.error = null
    state.currentTemplate.data = action.payload.questionnaire_template || action.payload
    state.templateQuestions.data = action.payload.data || action.payload
  },
  [failedQuestionnaireTemplate.type]: (state, action) => {
    state.currentTemplate.loading = false
    state.currentTemplate.error = action.payload || 'Failed to fetch template'
  },
  
  // Create Template
  [requestingCreateTemplate.type]: (state) => {
    state.loading = true
    state.error = null
  },
  [createTemplateSuccess.type]: (state, action) => {
    state.loading = false
    state.error = null
    const response = action.payload || {}
    const newTemplate = response.data || response
    
    if (Array.isArray(state.questionnaireTemplates.data)) {
      state.questionnaireTemplates.data.unshift(newTemplate)
    } else {
      state.questionnaireTemplates.data = [newTemplate]
    }
  },
  [createTemplateFailure.type]: (state, action) => {
    state.loading = false
    state.error = action.payload || 'Failed to create template'
  },


  [requestingSaveTemplateQuestions.type]: (state) => {
    state.loading = true
    state.error = null
  },
  [saveTemplateQuestionsSuccess.type]: (state, action) => {
    state.loading = false
    state.error = null
  },
  [saveTemplateQuestionsFailure.type]: (state, action) => {
    state.loading = false
    state.error = action.payload || 'Failed to create template'
  },
  
  // Update template actions
  [requestingUpdateTemplate.type]: (state) => {
    state.loading = true
    state.error = null
  },
  [updateTemplateSuccess.type]: (state, action) => {
    state.loading = false
    state.error = null
    const response = action.payload || {}
    const updatedTemplate = response.data || response
    
    if (Array.isArray(state.questionnaireTemplates.data)) {
      const index = state.questionnaireTemplates.data.findIndex(t => t.id === updatedTemplate.id)
      if (index !== -1) {
        state.questionnaireTemplates.data[index] = updatedTemplate
      }
    }
  },
  [updateTemplateFailure.type]: (state, action) => {
    state.loading = false
    state.error = action.payload || 'Failed to update template'
  },
  
  // Delete template reducers
  [requestingDeleteTemplate.type]: (state) => {
    state.loading = true
    state.error = null
  },
  [deleteTemplateSuccess.type]: (state, action) => {
    state.loading = false
    state.error = null
    const templateId = action.payload?.id || action.meta?.arg
    if (templateId && Array.isArray(state.questionnaireTemplates.data)) {
      state.questionnaireTemplates.data = state.questionnaireTemplates.data.filter(
        template => template.id !== templateId
      )
    }
  },
  [deleteTemplateFailure.type]: (state, action) => {
    state.loading = false
    state.error = action.payload || 'Failed to delete template'
  },
  
  // Questions
  [addQuestion.type]: (state, action) => {
    state.questions.push(action.payload)
  },
  [updateQuestion.type]: (state, action) => {
    const { id, updates } = action.payload
    const index = state.questions.findIndex(q => q.id === id)
    if (index !== -1) {
      state.questions[index] = { ...state.questions[index], ...updates }
    }
  },
  [deleteQuestion.type]: (state, action) => {
    state.questions = state.questions.filter(q => q.id !== action.payload)
  },
  [reorderQuestions.type]: (state, action) => {
    state.questions = action.payload
  },
  
  // Questionnaire Submission
  [submittingQuestionnaire.type]: (state) => {
    state.loading = true
    state.error = null
  },
  [submitQuestionnaireSuccess.type]: (state) => {
    state.loading = false
    state.error = null
  },
  [submitQuestionnaireFailure.type]: (state, action) => {
    state.loading = false
    state.error = action.payload || 'Failed to submit questionnaire'
  },
  [resetQuestions.type]: () => initialState
})

export default questionReducer

// Thunk action for fetching questionnaire templates
export const getQuestionnaireTemplates = (page, pageSize, status , search = '') => {
  const params = {
    page,
    per_page: pageSize,
    status,
    search: search.trim()
  }
  
  return api({
    url: '/guide/questionnaire_templates',
    method: 'get',
    params,
    onStart: requestedQuestionnaireTemplates.type,
    onSuccess: receivedQuestionnaireTemplates.type,
    onError: failedQuestionnaireTemplates.type
  })
}

// Thunk action for creating a new questionnaire template
export const createQuestionnaireTemplate = (templateData) => {
  return api({
    url: '/guide/questionnaire_templates',
    method: 'post',
    data: templateData,
    onStart: requestingCreateTemplate.type,
    onSuccess: createTemplateSuccess.type,
    onError: createTemplateFailure.type
  })
}

// Thunk action for updating an existing questionnaire template
export const updateQuestionnaireTemplate = (templateId, templateData) => {
  return api({
    url: `/guide/questionnaire_templates/${templateId}`,
    method: 'put',
    data: templateData,
    onStart: requestingUpdateTemplate.type,
    onSuccess: updateTemplateSuccess.type,
    onError: updateTemplateFailure.type
  })
}
// Thunk action for deleting a questionnaire template
export const deleteQuestionnaireTemplate = (templateId) => {
  return api({
    url: `/guide/questionnaire_templates/${templateId}`,
    method: 'delete',
    onStart: requestingDeleteTemplate.type,
    onSuccess: deleteTemplateSuccess.type,
    onError: deleteTemplateFailure.type,
    successMessage: 'Template deleted successfully',
    errorMessage: 'Failed to delete template'
  })
}

// Thunk action for fetching a single questionnaire template by ID
export const getQuestionnaireTemplateById = (templateId) => {
  return api({
    url: `/guide/questionnaire_templates/${templateId}/questions`,
    method: 'get',
    onStart: requestedQuestionnaireTemplate.type,
    onSuccess: receivedQuestionnaireTemplate.type,
    onError: failedQuestionnaireTemplate.type,
    errorMessage: 'Failed to fetch template details'
  })
}

// Thunk action for saving questionnaire template questions
export const saveQuestionnaireTemplateQuestions = (templateId, questions) => {
  return api({
    url: `/guide/questionnaire_templates/${templateId}/questions`,
    method: 'post',
    data:  questions ,
    onStart: requestingSaveTemplateQuestions.type,
    onSuccess: saveTemplateQuestionsSuccess.type,
    onError: saveTemplateQuestionsFailure.type,
    successMessage: 'Questions saved successfully',
    errorMessage: 'Failed to save questions'
  })
}
export const updateQuestionnaireTemplateQuestions = (templateId, questions) => {
  return api({
    url: `/guide/questionnaire_templates/${templateId}/questions`,
    method: 'put',
    data: questions,
    onStart: requestingSaveTemplateQuestions.type,
    onSuccess: saveTemplateQuestionsSuccess.type,
    onError: saveTemplateQuestionsFailure.type,
    successMessage: 'Questions updated successfully',
    errorMessage: 'Failed to update questions'
  })
}

// Thunk action for fetching booking questionnaire by ID
export const getBookingQuestionnaire = (bookingId) => {
  return api({
    url: `/booking_questionnaires/${bookingId}`,
    method: 'get',
    onStart: requestedBookingQuestionnaire.type,
    onSuccess: receivedBookingQuestionnaire.type,
    onError: failedBookingQuestionnaire.type,
    errorMessage: 'Failed to fetch booking questionnaire'
  })
}

export const duplicateQuestionnaireTemplate = (templateId, options = {}) => {
    return api({
    url: `/guide/questionnaire_templates/${templateId}/duplicate`,
    method: 'post',
    data: options,
    onStart: requestingDuplicateTemplate.type,
    onSuccess: duplicateTemplateSuccess.type,
    onError: duplicateTemplateFailure.type,
    successMessage: 'Template duplicated successfully',
    errorMessage: 'Failed to duplicate template'
  })
}

/**
 * Thunk action for submitting questionnaire responses
 * @param {number} questionnaireId - The ID of the questionnaire to submit
 * @param {Object} responses - The questionnaire responses to submit
 * @returns {Promise} - Resolves with the API response data
 */
export const submitQuestionnaire = (questionnaireId,answers) => {
  return api({
    url: `/booking_questionnaires/${questionnaireId}/submit_questionnaire`,
    method: 'post',
    data: {answers},
    onStart: submittingQuestionnaire.type,
    onSuccess: submitQuestionnaireSuccess.type,
    onError: submitQuestionnaireFailure.type,
    successMessage: 'Questionnaire submitted successfully',
    errorMessage: 'Failed to submit questionnaire'
  })
}
